import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../utils/store';

export interface DeleteAccountModalState {
    isOpen: boolean;
    userId: string;
}

const initialState: DeleteAccountModalState = {
    isOpen: false,
    userId: '',
};

export const slice = createSlice({
    name: 'deleteAccountModal',
    initialState,
    reducers: {
        setOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        setUserId: (state, action: PayloadAction<string>) => {
            state.userId = action.payload;
        },
    },
});

export const { setOpen, setUserId } = slice.actions;
export const actions = slice.actions;

export const selectIsOpen = (state: RootState) =>
    state.deleteAccountModal.isOpen;
export const selectUserId = (state: RootState) =>
    state.deleteAccountModal.userId;

export default slice.reducer;
